import { FC, JSX, useContext, useRef, useState } from "react";
/* oxlint-disable-next-line import/no-cycle */
import EcdPreviewModal from "@app/overviews/enterprise-compliance-dashboard/components/EcdPreviewModal";
import { UserContext } from "@app/user/UserContext";
import { QESButton } from "@app/shared/qes-standards/Button";
import { EcdGenerateReportContext } from "@app/overviews/enterprise-compliance-dashboard/contexts/EcdGenerateReportContext";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface EcdReportPreviewTileProps {
  showExpand: boolean;
  tileContent: JSX.Element;
  title?: string;
}

const EcdExportWrapper: FC<EcdReportPreviewTileProps> = (props: EcdReportPreviewTileProps) => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const user = useContext(UserContext);
  const expandTitle = props.title;

  const [isVisible, setIsVisible] = useState(false);
  const modalTrigger = useRef<HTMLButtonElement>(null);

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div className="ecd-export__width">
      <div className="ecd-export__border">
         <div className="d-flex flex-column w-100" style={{ padding: "10px" }}>
          <div className="d-flex flex-row align-items-center w-100">
            <img className="ecd-export__logo" id="logo" src={`${window.customUIBaseUrl}/images/QuestAnalyticsLogo-R.png`} role="img" alt="Quest Analytics (registered trademark)" />
            <span>
                <span className="qes-dashboard-tile__title ecd-export__head"> {wizardContext.fileName} </span><br />
                <span className="qes-dashboard-tile__title ecd-export__subhead"> {new Date().toLocaleDateString("en-us", { day: "numeric", month: "short", year: "numeric" })} </span><br />
                <span className="qes-dashboard-tile__title ecd-export__subhead"> {"Generated by: " + user.displayName} </span>
            </span>
            {props.showExpand &&
              <QESButton
                qesTestId="ecd-export-preview-expand-button"
                className="ecd-preview-button"
                qesType="secondary"
                onClick={() => setIsVisible(true)}
                aria-label="Open Popup"
                style={{ marginLeft: "auto", padding: ".5em" }}>
                  <QesIcon iconName={QesIcons.ExpandV1} description="Expand preview" width="60px" />
              </QESButton>}
          </div>
          {props.tileContent}
        </div>
      </div>
      {props.showExpand &&
        <EcdPreviewModal
          closeModal={handleClose}
          isVisible={isVisible}
          body={props.tileContent}
          title={expandTitle}
          triggerElement={modalTrigger} />
      }
    </div>
  )
}

export default EcdExportWrapper;